
import type { PropType } from 'vue'
import type { ExplainMessages } from '../../../models/i18n/explain.messages'
import { computed, defineComponent, getCurrentInstance, onMounted, watch } from 'vue'
import { useContextQuery, useEpb, useX } from '../../../composables'
import { CONTAINER } from '../../../config/inversify.config'
import { TYPES } from '../../../config/inversify.types'
import ExplainSearchBoxBase from '../explain-search-box-base.component.vue'

export default defineComponent({
  name: 'ExplainSearchSearchBox',
  components: {
    ExplainSearchBoxBase,
  },
  props: {
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    placeholder: {
      type: String as PropType<string>,
      required: true,
    },
    inputQuery: {
      type: String as PropType<string>,
      default: '',
    },
  },
  setup(props, { emit }) {
    const {
      proxy: { $x },
    } = getCurrentInstance()

    const { $epb } = useEpb()
    const { query, setQuery, clearQuery } = useContextQuery()
    const {
      query: xQuery,
      setQuery: setXQuery,
      setQueryFromUrl: setXQueryFromUrl,
      clearQuery: clearXQuery,
    } = useX()

    const messages = $epb.messages.explain as ExplainMessages

    const xSearchBoxComponent = CONTAINER.get(TYPES.XSearchBoxComponent)

    const computedPlaceholder = computed(() => {
      return props.disabled ? messages.search.selectFiltersPlaceholder : props.placeholder
    })

    onMounted(() => {
      if (query.value) {
        setXQueryFromUrl(query.value)
      } else {
        if (!props.inputQuery) {
          clearXQuery()
        }
      }
    })

    watch(
      () => $x.query.search,
      (query: string) => {
        if (query) {
          setQuery(query)
        } else {
          clearQuery()
        }
      },
    )

    watch(
      () => $x.query.searchBox,
      (inputQuery: string) => {
        emit('input', inputQuery)
      },
    )

    watch(
      () => query.value,
      (query: string) => {
        if (query) {
          setXQuery(query)
        } else {
          if (!props.inputQuery) {
            clearXQuery()
          }
        }
      },
    )

    return {
      baseClass: 'epb-explain-search-search-box',
      query,
      setQuery,
      clearQuery,
      computedPlaceholder,
      xSearchBoxComponent,
    }
  },
})
